import { defineAction } from '~/prix'
import answerListAction from './answerList.action.json' with { type: 'json' }
import { answerObject } from '../answerObject'
import { z } from 'zod'

const answerListDefinition = defineAction({
  ...answerListAction,
  input: z.object({}),
  output: z.object({
    items: z.array(answerObject),
    count: z.number(),
  }),
})

export default answerListDefinition
